/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import DropdownItem from './dropdownItem';

const Dropdown = (props) => {
    if(props.hidden == true) {
        return (
            <div className="nav-dropdown hidden absolute mt-6 bg-black py-8 pl-11 pr-16 rounded-lg">
                <div className="header mb-10">
                    <h1 className="text-gray-300 font-semibold mb-1.5">{props.title}</h1>
                    <hr className="border-primary w-10" />
                </div>
                <div className="body">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-x-6 gap-y-5">
                        {props.items.map(item => <DropdownItem data={item} /> )}
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="nav-dropdown block absolute mt-6 bg-black py-8 pl-11 pr-16 rounded-lg">
                <div className="header mb-10">
                    <h1 className="text-gray-300 font-semibold mb-1.5">{props.title}</h1>
                    <hr className="border-primary w-10" />
                </div>
                <div className="body">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-x-6 gap-y-5">
                        {props.items.map(item => <DropdownItem data={item} /> )}
                    </div>
                </div>
            </div>
        )
    }
}

export default Dropdown